/*
 * @Author: lc 2631402207@qq.com
 * @Date: 2025-11-06 18:47:57
 * @LastEditors: lc 2631402207@qq.com
 * @LastEditTime: 2025-11-10 12:57:26
 * @FilePath: \senlan-ai-ui\src\routers\modules\RouterBefore.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { useEffect } from 'react'
import { useLoaderData, useNavigate, useLocation } from 'react-router-dom'
import { WHITE_LIST, LOGIN_PATH, HOME_PATH } from '../../config/index.ts'
/**
 * @description 设置路由守卫
 */
interface RouterGuardProps {
  children: React.ReactNode
}
const RouterGuard: React.FC<RouterGuardProps> = (props) => {
  const loader = useLoaderData() //此钩子用于获取路由加载器（laoder）所返回的数据
  const navigate = useNavigate() //此钩子用于编程式路由导航
  const { pathname } = useLocation() //此钩子用于返回location对象

  useEffect(() => {
    const token = localStorage.getItem(import.meta.env.VITE_TOKEN_KEY)
    // 如果是白名单，直接返回
    if (WHITE_LIST.includes(pathname)) return

    // 如果在已登录的情况下，直接访问登录页
    if (token && pathname === LOGIN_PATH) {
      navigate(HOME_PATH, { replace: true })
      return
    }

    // 如果在未登录的情况下，访问登录页
    if (!token && pathname === LOGIN_PATH) return
  }, [loader])

  // 返回当前组件
  return props.children
}

export default RouterGuard
